import { Station } from 'dataSources/Typicode/stations';

import { checkIsSelectedStation } from './checkIconType';

import { ROADSIDE_SERVICES_CODES } from 'common/constants/index';
import { STATION_TYPES } from 'common/constants/stationTypes';

const getActiveStatus = (
    stationCode: Station['code'],
    selectedStationCode: Station['code']
) => (
  checkIsSelectedStation(stationCode, selectedStationCode) 
  ? 'Active' : ''
);

const getSelectedOnRouteStatus = (
    selectedOnRoute: boolean
) => (
  selectedOnRoute 
  ? 'SelectedOnRoute' : ''
);

const getFavouriteStatus = (favourite: boolean) => (
  favourite ? 'Favourite' : ''
);

const getStationType = (categoryCode: number) => ({
  2: STATION_TYPES.discountPlusPetrolStation,
  4: STATION_TYPES.powerMaxPetrolStation,
  5: STATION_TYPES.economyPetrolStation
}[categoryCode]);

export const getIconName = ({
  data = {},
  clusterWeight = 0,
  selectedOnRoute,
  selectedStation
}: any) => {
  if (clusterWeight > 1) {
    return clusterWeight < 1000 ? 'cluster' : 'largeCluster'
  }

  if (!data.code) {
    return 'place';
  }

  const isGasStation = data.roadsideServiceCodes[0] === ROADSIDE_SERVICES_CODES.gasStation;

  if(!data.roadsideServiceCodes.length || (isGasStation && !getStationType(data.categoryCode))) {
    return 'station'
      + getActiveStatus(data.code, selectedStation)
      + getSelectedOnRouteStatus(selectedOnRoute)
      + getFavouriteStatus(data.favourite)
      + '1';
  }

  if (isGasStation) {
    return 'station'
      + getActiveStatus(data.code, selectedStation)
      + getSelectedOnRouteStatus(selectedOnRoute)
      + getFavouriteStatus(data.favourite)
      + data.categoryCode
  }

  return 'roadsideService'
    + getActiveStatus(data.code, selectedStation)
    + getSelectedOnRouteStatus(selectedOnRoute)
    + getFavouriteStatus(data.favourite)
    + data.roadsideServiceCodes[0];
};
